export default __webpack_public_path__ + "static/media/img2.de0d193a.png";